/* eslint-disable func-names */
import { Loader } from "@googlemaps/js-api-loader";

const loader = new Loader({
  apiKey: window.data.googleMapApiKey,
  version: "weekly",
});

loader.load().then(() => {
  let infoWindow = null;
  const locationMarkers = {};
  const map = new google.maps.Map(document.getElementById("map"), {
    center: { lat: 51.165691, lng: 10.451526 },
    disableDefaultUI: true,
    gestureHandling: "cooperative",
    zoom: window.matchMedia("(max-width: 599px)").matches ? 5 : 6,
  });

  window.closeInfoWindow = () => {
    if (infoWindow !== null) {
      infoWindow.close();
      infoWindow = null;
    }
  };

  function showLocationDetails(locationName, url, jobsUrl, jobsCount) {
    if (infoWindow !== null) {
      infoWindow.close();
    }

    infoWindow = new google.maps.InfoWindow({
      content: `<div>
        <div class="mb-[10px] flex items-center justify-between">
          <span class="font-semibold text-brand-gray-800">${locationName}</span>
          <button onclick="window.closeInfoWindow();" type="button">
            <svg
              version="1.2"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              overflow="visible"
              preserveAspectRatio="none"
              viewBox="0 0 102 102"
              x="0px"
              y="0px"
              width="10"
              height="10"
              xml:space="preserve"
            >
                <polygon
                  points="89.7,0 50,39.6 10.3,0 0,10.3 39.6,50 0,89.7 10.3,100 50,60.4 89.7,100 100,89.7 60.4,50 100,10.3"
                  vector-effect="non-scaling-stroke"
                />
            </svg>
          </button>
        </div>
        <div class="flex items-center gap-[20px] [&_a]:transition-colors [&_a]:text-brand [&_a:hover]:text-brand-orange">
          <a href="${url}">${django.gettext("mehr erfahren")}</a>
          <a href="${jobsUrl}">${jobsCount} ${django.gettext(
        "offene Stellen"
      )}</a>
        </div>
      </div>`,
    });

    infoWindow.open({
      anchor: locationMarkers[locationName],
      map,
      shouldFocus: false,
    });
  }

  document
    .querySelectorAll(".ch24-locationsMapContainerOverlay-country")
    .forEach(function (countryElement) {
      countryElement.addEventListener("click", function () {
        const country =
          window.data.coordinates[countryElement.dataset.countryCode];
        map.setCenter({ lat: country.lat, lng: country.lng });
        map.setZoom(6);
      });
    });

  document
    .querySelectorAll(".ch24-location-officesAddress")
    .forEach(function (office) {
      office.addEventListener("click", function () {
        const country = window.data.coordinates[office.dataset.officeCountry];
        const officeCoordinatesIndex = country.items?.findIndex(
          ({ name }) => name === office.dataset.officeId
        );

        if (officeCoordinatesIndex === -1) {
          return;
        }

        const {
          lat,
          lng,
          name: locationName,
          url,
          jobs_count: jobsCount,
          jobs_url: jobsUrl,
        } = country.items[officeCoordinatesIndex];
        map.setCenter({ lat, lng });
        map.setZoom(13);

        showLocationDetails(locationName, url, jobsUrl, jobsCount);
      });
    });

  Object.values(window.data.coordinates || {}).forEach(({ items, name }) => {
    items.forEach(
      ({
        lat,
        lng,
        name: locationName,
        url,
        jobs_count: jobsCount,
        jobs_url: jobsUrl,
      }) => {
        locationMarkers[locationName] = new google.maps.Marker({
          position: { lat, lng },
          title: name,
          icon: window.data.mapMarkerUrl,
          map,
        });

        locationMarkers[locationName].addListener("click", () => {
          showLocationDetails(locationName, url, jobsUrl, jobsCount);
        });
      }
    );
  });
});
